const en = {
    translation: {
        button: {
            back: 'Back',
            backToAccountServices: 'BACK TO ACCOUNT SERVICES',
            cancel: 'CANCEL',
            changeDueDate: 'Change Due Date',
            close: 'CLOSE',
            creditLimitIncrease: 'Credit Limit Increase',
            submit: 'Submit'
        },
        changePaymentDueDate: {
            changePaymentDueDate: 'Change payment due date',
            modalHeader: 'Change Due Date'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Please call (800) 508-2520 for assistance. We’re always available to help, call us 24/7.',
                title: 'We’re having trouble verifying your identity'
            },
            addPrimaryHolder: {
                extraInfo: 'Try again with another name.',
                subTitle: 'You entered the name of the Primary Cardholder who already has a card.',
                title: 'Please try again'
            },
            addressChanged: 'We cannot process your request since your address was changed in the last 30 days.',
            dueDateChangePeriodRestriction: {
                subTitle: 'You can change your due date once every 12 months.',
                title: 'You can’t change your due date right now'
            },
            nameChanged: 'We cannot process your request since your first name was changed in the last 30 days.',
            notEligible: {
                body: 'We cannot process your request for Change Due Date at this time.',
                title: 'Your account is not eligible'
            },
            notEligibleAccount: 'Your account is not eligible',
            profanity: {
                title: 'Please try again',
                unapprovedName: 'The name(s) you gave us couldn’t be accepted as entered. Please make any corrections and try again.'
            },
            troubleAccessingAccount: 'We’re having trouble accessing your account',
            troubleRetrievingInformation: 'We’re having trouble retrieving your information',
            tryAgainLater: 'Please try again later.'
        },
        mocks: {
            accountEnding: 'Account ending in {{accountLast4}}',
            availableToSpend: 'Available to spend',
            beginLogin: 'Begin Login',
            cardAccountEnding: 'Card for account ending in {{accountLast4}}',
            clientId: 'Enter a Client ID',
            currentBalance: 'Current Balance',
            environment: 'Choose an Environment',
            logout: 'Logout',
            makeAPayment: 'Make a Payment',
            paymentDueDate: 'Payment Due Date',
            totalMinimumPayment: 'Total Minimum Payment'
        },
        modal: {
            closeDialog: 'Close Dialog',
            header: 'Credit Limit Increase'
        },
        text: {
            accountActions: 'Account Actions',
            accountServices: 'Account Services',
            manageCardHolders: 'Manage cardholders',
            paymentSecurity: 'Payment Security',
            balanceTransferOffers: 'Balance Transfer Offers'
        }
    }
};
export default en;
